import { useState as E, useEffect as I } from "react";
import { g as p } from "./_commonjsHelpers-OnjxAlhP.js";
import { i as l } from "./isClient-bZWD-rdJ.js";
import { w as y } from "./useMetaContent-M9Eg3hyC.js";
const B = (t) => {
  const { window: n, document: s } = p();
  !n || !s || (n.twttr = function(a, f, e) {
    const c = a.getElementsByTagName(f)[0];
    if (!(c != null && c.parentNode))
      return;
    const i = n.twttr ?? {
      _e: [],
      ready: function(r) {
        this._e.push(r);
      }
    };
    if (a.getElementById(e))
      return i;
    const u = a.createElement(f);
    return u.id = e, u.src = t, c.parentNode.insertBefore(u, c), i;
  }(s, "script", "twitter-wjs"));
}, R = (t) => t.type === "x-embed" && "postId" in t, x = (t) => t.type === "instagram-embed" && "html" in t, F = ({ postId: t, scriptSource: n, onLoad: s }, a) => {
  const [f, e] = E(!0);
  return I(() => {
    var i, u, r;
    const c = t && n && !((i = a.current) != null && i.childNodes.length);
    if (B(n), c) {
      const d = (u = p()) == null ? void 0 : u.window;
      (r = d == null ? void 0 : d.twttr) == null || r.ready(() => {
        var m, o;
        a.current && ((o = (m = d == null ? void 0 : d.twttr) == null ? void 0 : m.widgets) == null || o.createTweet(t, a.current).then(() => {
          e(!1), s == null || s();
        }).catch((w) => (console.error(
          `Error creating X (Twitter) widget with tweetId: ${t} and scriptSrc: ${n}`,
          w
        ), e(!1))));
      });
    } else
      e(!1);
  }, []), f;
}, M = ({ html: t, scriptSource: n, onLoad: s }, a) => {
  const [f, e] = E(!0);
  return I(() => {
    var u, r, d, m, o, w;
    if (!l || !t || !n || !a.current) {
      e(!1);
      return;
    }
    const c = () => {
      e(!1);
      const g = setInterval(() => {
        var N, C, T, b;
        const h = (C = (N = p()) == null ? void 0 : N.window) == null ? void 0 : C.instgrm;
        h != null && h.Embeds && (clearInterval(g), (b = (T = h.Embeds).process) == null || b.call(T), s == null || s());
      }, 500);
      return () => clearInterval(g);
    }, i = (r = (u = p()) == null ? void 0 : u.document) == null ? void 0 : r.getElementById("instagram-embed-script");
    if (i)
      c();
    else {
      const g = (m = (d = p()) == null ? void 0 : d.document) == null ? void 0 : m.createElement("script");
      g && (g.src = n, g.id = "instagram-embed-script", g.async = !0, g.onload = c, (w = (o = p()) == null ? void 0 : o.document) == null || w.body.appendChild(g));
    }
    return () => {
      i != null && i.parentNode && i.parentNode.removeChild(i);
    };
  }, [t, n, a]), f;
}, O = (t, n, s) => {
  var i;
  const [a, f] = E(!1), e = (i = p()) == null ? void 0 : i.window, c = (u) => {
    var o, w;
    const r = (o = e == null ? void 0 : e.document) == null ? void 0 : o.activeElement, d = (r == null ? void 0 : r.tagName) === "IFRAME" && (r == null ? void 0 : r.getAttribute("data-tweet-id")) === n, m = (r == null ? void 0 : r.tagName) === "IFRAME" && ((w = r.parentNode) == null ? void 0 : w.getAttribute("id")) === n;
    (d || m) && (f(!0), t == null || t(u));
  };
  return I(() => {
    var d, m;
    if (!l)
      return;
    const u = (m = (d = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : d.toLowerCase()) == null ? void 0 : m.includes("firefox"), r = (o) => {
      u ? e == null || e.setTimeout(() => c(o), 0) : c(o);
    };
    return e == null || e.addEventListener("blur", r), () => e == null ? void 0 : e.removeEventListener("blur", r);
  }, [t, n, c]), I(() => {
    l && a && s !== "keyboard" && (f(!1), e == null || e.focus());
  }, [a, s]), a;
}, P = () => {
  const [t, n] = E(y.ask());
  return I(() => {
    const s = () => n(y.ask());
    return y.registerOnChange(s, "input"), () => y.unRegisterOnChange(s);
  }, []), t;
};
export {
  P as a,
  M as b,
  F as c,
  x as d,
  R as i,
  O as u
};
